<template>
    <form-template @submit="proceed">
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Select Provider</p>
        </div>
        <template v-if="categories.length">
            <div class="col-span-4 md:col-span-3">
                <div class="grid grid-cols-4 gap-3 w-full">
                    <div class="col-span-4 md:col-span-3" v-for="val in categories" :key="val.id">
                        <div class="w-full">
                            <biller-radio
                                @select="(item) => select(item, val)"
                                :value="val.biller_name"
                                :active="data.biller_id === val.id"
                            >
                                <div class="flex items-center">
                                    <img src="@/assets/img/waec.png" class="w-10" />
                                    <p class="text-grey-300 text-sm ml-3">{{ val.biller_name }}</p>
                                </div>
                            </biller-radio>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="col-span-4 md:col-span-3">
                <div class="grid grid-cols-4 gap-3 w-full">
                    <div class="col-span-4 md:col-span-3" v-for="index in 3" :key="index">
                        <div class="w-full">
                            <telco-skeleton-loader />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </form-template>
</template>

<script>
import TelcoSkeletonLoader from '@/components/ui/TelcoSkeletonLoader'
import { mapActions, mapGetters } from 'vuex'
export default {
    metaInfo: {
        title: 'Education',
    },
    data() {
        return {
            meter: '',
            selectedCable: '',
            data: {
                biller_id: '',
                amount: '',
            },
        }
    },
    methods: {
        select(item, val) {
            this.data.biller_id = val.id
            this.data.amount = val.amount.split('.')[0]
        },

        ...mapActions('Bill', {
            getCategories: 'FETCH_EDUCATION_CATEGORIES',
        }),

        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
            setWarning: 'SET_WARNING',
        }),

        proceed(val) {
            if (this.data.biller_id) {
                const fullData = Object.assign(this.data, val)
                this.$emit('proceed', fullData)
            } else {
                this.setMessage('Please select a provider')
                this.setWarning('warning')
            }
        },
    },

    mounted() {
        this.getCategories()
    },

    computed: {
        ...mapGetters('Bill', {
            categories: 'GET_EDUCATION_CATEGORIES',
        }),
    },

    components: {
        TelcoSkeletonLoader,
    },
}
</script>

<style></style>
